import React from 'react';
import './Toggle.css';

/**
 * Toggle Component
 * Standardized switch/toggle input
 * 
 * @param {string} label - Toggle label
 * @param {string} description - Description text below label
 * @param {boolean} checked - Checked state
 * @param {function} onChange - Change handler: (checked: boolean) => void
 * @param {boolean} disabled - Disabled state
 * @param {string} size - Toggle size: 'small' | 'medium' | 'large' (default: 'medium')
 * @param {string} className - Additional CSS classes
 */
const Toggle = ({
  label,
  description,
  checked = false,
  onChange,
  disabled = false,
  size = 'medium',
  className = ''
}) => {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  const toggleId = `toggle-${Math.random().toString(36).substr(2, 9)}`;
  const sizeClass = `toggle-${size}`;

  return (
    <div className={`toggle-container ${className}`.trim()}>
      <label htmlFor={toggleId} className={`toggle-label ${disabled ? 'disabled' : ''}`}>
        <div className="toggle-content">
          <div className="toggle-text">
            {label && (
              <span className="toggle-label-text">{label}</span>
            )}
            {description && (
              <span className="toggle-description">{description}</span>
            )}
          </div>
          <div className={`toggle-switch ${sizeClass} ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
            <input
              type="checkbox"
              id={toggleId}
              checked={checked}
              onChange={handleChange}
              disabled={disabled}
              className="toggle-input"
              aria-describedby={description ? `${toggleId}-description` : undefined}
            />
            <span className="toggle-slider"></span>
          </div>
        </div>
        {description && (
          <span id={`${toggleId}-description`} className="toggle-description-full">
            {description}
          </span>
        )}
      </label>
    </div>
  );
};

export default Toggle;










